import { RouterProvider, createBrowserRouter, useLocation, useRouteError, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import DefaultLayout from "./layouts/DefaultLayout";
import Home from './pages/Home';
import AggiornamentoDati from "./pages/AggiornamentoDati";
import AuthLayout from "./layouts/AuthLayout";
import LinearLayout from "./layouts/LinearLayout";
import Appuntamenti from "./pages/Appuntamenti";
import NewAppointment from "./pages/NewAppointment";
import AnagraficaClienti from "./pages/AnagraficaClienti";
import 'preline/dist/preline.js'
import AnagraficaClientiDetail from "./pages/AnagraficaClientiDetail";
import FidoDetail from "./pages/FidoDetail";
import { Provider } from 'react-redux'
import configureStore from './redux/store';
import EditAppointment from "./pages/EditAppointment";
import GuestRoute from "./utils/GuestRoute";
import Ordini from "./pages/Ordini";
import OrdiniDetail from "./pages/OrdiniDetail";
import Backorder from "./pages/Backorder";
import Dashboard from "./pages/Dashboard";
import FidoClienti from "./pages/Fido_clienti";
import Billed from "./pages/Billed";
import AuthWrapper from './components/AuthWrapper'; // Importa il nuovo componente
import Disponibilita from "./pages/Disponibilita";
import Documenti from "./pages/Documenti";
import UserProfile from "./pages/UserProfile";

function ErrorBoundary() {
  let error = useRouteError();
  return <div></div>;
}


const router = createBrowserRouter([
  {
    path: "/login",
    element: <AuthLayout />,
    children: [
      {
        index: true,
        Component: GuestRoute,
      },
    ],
  },
  {
    path: "/",
    element: (
      <AuthWrapper>
        <LinearLayout />
      </AuthWrapper>
    ),
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        Component: Home,
      },
    ],
  },
  {
    path: "/",
    element: (
      <AuthWrapper>
        <DefaultLayout />
      </AuthWrapper>
    ),
    children: [
      {
        path: "aggiornamento-dati",
        Component: AggiornamentoDati,
      },
      {
        path: "appuntamenti",
        Component: Appuntamenti,
      },
      {
        path: "appuntamenti/new",
        Component: NewAppointment,
      },
      {
        path: "appuntamenti/:id/edit",
        Component: EditAppointment,
      },
      {
        path: "anagrafica-clienti",
        Component: AnagraficaClienti,
      },
      {
        path: "anagrafica-clienti/:id/detail",
        Component: AnagraficaClientiDetail,
      },
      {
        path: "fido-clienti/:id/detail",
        Component: FidoDetail,
      },
      {
        path: "ordini",
        Component: Ordini,
      },
      {
        path: "ordini/:id/detail",
        Component: OrdiniDetail,
      },
      {
        path: "anagrafica-clienti/:id/detail",
        Component: AnagraficaClientiDetail,
      },
      {
        path: "fido-clienti/:id/detail",
        Component: FidoClienti,
      },
      {
        path: "dashboard",
        Component: Dashboard,
      },
      {
        path: "backorder",
        Component: Backorder,
      },
      {
        path: "fido-clienti",
        Component: FidoClienti,
      },
      {
        path: "fatturato",
        Component: Billed,
      },
      {
        path: "disponibilita",
        Component: Disponibilita,
      },
      {
        path: "Documenti",
        Component: Documenti,
      },
      {
        path: "user-profile",
        Component: UserProfile,
      },
    ],
  },
]);


function App() {

  return (
    <Provider store={configureStore()}>
      <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
    </Provider>
  )
}

export default App
